
import { LocalVideoTrack, Room as TwilioRoom } from 'twilio-video';

// 화면공유 트랙 식별자 — 수신 측(TwilioHelper)에서 카메라 비디오와 구분해
// 전용 뷰어로 라우팅하기 위한 트랙 이름. 양측에서 동일하게 참조한다.
export const SCREEN_TRACK_NAME = 'screen';

export class ScreensharingHelper {
  screenTrack?: LocalVideoTrack;

  async startSharing(twilioRoom: TwilioRoom, onStop: ()=>void): Promise<'busy' | 'started' | 'failed'> {
    let existingScreenSharing = Array.from(twilioRoom.participants.values() ?? []).find(rp => rp.videoTracks.size > 0);;
    if (existingScreenSharing) {
      return 'busy';
    } else {
      try {
        let stream = await navigator.mediaDevices.getDisplayMedia();
        // 트랙에 'screen' 이름을 부여해 수신 측에서 화면공유로 식별 가능하게 하고,
        // priority 'high'로 발행해 화면 텍스트 가독성(해상도)을 우선 확보한다.
        let track = new LocalVideoTrack(stream.getTracks()[0], { name: SCREEN_TRACK_NAME });
        this.screenTrack = track;
        await twilioRoom.localParticipant.publishTrack(track, { priority: 'high' });
        track.mediaStreamTrack.onended = () => { this.stopSharing(twilioRoom); onStop();};
        return 'started';
      } catch (error) {
        alert(error);
        return 'failed';
      }
    }
  }

  stopSharing(twilioRoom: TwilioRoom | undefined) {
    if (this.screenTrack) {
      this.screenTrack.stop();
      twilioRoom?.localParticipant.unpublishTrack(this.screenTrack);
      this.screenTrack = undefined;
    }
  }

  isSharing() {
    return !!this.screenTrack && this.screenTrack.isEnabled;
  }

}
